const PREFIX = "Shared/AdditionalQuestion/";

export const RECEIVE_ADDITIONAL_QUESTIONS = `${PREFIX}RECEIVE_ADDITIONAL_QUESTIONS`;

export const REMOVE_ADDITIONAL_QUESTIONS = `${PREFIX}REMOVE_ADDITIONAL_QUESTIONS`;
